import { Pipe, PipeTransform } from '@angular/core';
import {
	AIMessage,
	BaseMessage,
	HumanMessage,
	MessageType,
} from '@langchain/core/messages';

@Pipe({ name: 'messageRole', pure: true })
export class MessageRolePipe implements PipeTransform {
	transform(value: BaseMessage | undefined): MessageType {
		return value?.type ?? 'unknown';
	}
}

@Pipe({ name: 'messageIcon', pure: true })
export class MessageIconPipe implements PipeTransform {
	transform(value: BaseMessage | undefined): string {
		switch (value?.type) {
			case 'ai':
				return 'auto_awesome';
			case 'human':
				return 'person';
			case 'system':
				return 'settings';
			case 'tool':
				return 'build';
			default:
				return 'help';
		}
	}
}

@Pipe({ name: 'isHuman', pure: true })
export class IsHumanPipe implements PipeTransform {
	transform(value: BaseMessage | undefined): boolean {
		return HumanMessage.isInstance(value);
	}
}

@Pipe({ name: 'isAI', pure: true })
export class IsAIPipe implements PipeTransform {
	transform(value: BaseMessage): boolean {
		return AIMessage.isInstance(value);
	}
}
